import unitJobs from "@frog/source/data/unitJobs.js"
import games from "@frog/source/data/games/index.js"
import unitSprites from "@frog/source/data/unitSprites.js"
import Preload from "@frog/source/engine/Preload.js"

const preload = {"images": {}}

const imageURLs = [
    require("@frog/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-attack.png"),
    require("@frog/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-support.png"),
    require("@frog/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-reposition.png"),
    require("@frog/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-harvest.png"),
    require("@frog/source/assets/images/ember-tactics/sprites/interact-icons/interact-icons-kindle.png"),
    require("@frog/source/assets/images/pirate-tactics/wpn-triangle.png"),
    require("@frog/source/assets/images/pirate-tactics/ui/compass2.png"),
    require("@frog/source/assets/images/pirate-tactics/ui/compass.png"),
    require("@frog/source/assets/images/pirate-tactics/ui/dialoguebox.png"),
    require("@frog/source/assets/images/horror-tactics/warning-redo-1.png"),
    require("@frog/source/assets/images/horror-tactics/titlescreen-bgwithillust.png"),
    require("@frog/source/assets/images/horror-tactics/titlescreen-title.png"),
    require("@frog/source/assets/images/horror-tactics/ui/undo-btn.png"),
    require("@frog/source/assets/images/horror-tactics/ui/undo-btn-hover.png"),
    require("@frog/source/assets/images/horror-tactics/ui/undo-btn-close.png"),
    require("@frog/source/assets/images/horror-tactics/ui/endturn-btn.png"),
    require("@frog/source/assets/images/horror-tactics/ui/endturn-btn-hover.png"),
    require("@frog/source/assets/images/horror-tactics/ui/endturn-btn-close.png"),
]
Object.values(imageURLs).map((imageURL) => {
    preload.images[imageURL] = {"url": imageURL}
})


Object.values(unitSprites).map((unitSpritesSection) => {
    Object.values(unitSpritesSection).forEach((imageURL) => {
        preload.images[imageURL] = {"url": imageURL}
    })
})
preload.images[Object.keys(preload.images)[1]].paletteKeys = ["red", "blue"]

Object.values(unitJobs).forEach((unit) => {
    if(unit.portraits != undefined) {
        Object.values(unit.portraits).forEach((portrait) => {
            const imageURL = portrait
            preload.images[imageURL] = {"url": imageURL}
        })
    }
    if(unit.sprites != undefined) {
        Object.keys(unit.sprites).forEach((spriteKey) => {
            const sprite = unit.sprites[spriteKey]
            if(sprite.parts instanceof Array) {
                sprite.parts.forEach((spritepart) => {
                    if(spritepart.image != undefined) {
                        const imageURL = spritepart.image
                        preload.images[imageURL] = {"url": imageURL}
                    }
                    if(spritepart.animation?.frames != undefined) {
                        spritepart.animation?.frames.forEach((frame) => {
                            const imageURL = frame.image
                            preload.images[imageURL] = {"url": imageURL}
                        })
                    }
                })
            }
            if(sprite.frames instanceof Array) {
                sprite.frames.forEach((frame) => {
                    const imageURL = frame.image
                    preload.images[imageURL] = {"url": imageURL}
                })
            }
        })
    }
})

Object.values(games).forEach((game) => {
    Object.values(game.chapters).forEach((chapter) => {
        let images = chapter.stage.images || [chapter.stage.image]
        images.forEach((image) => {
            if(image == undefined) return
            const url = image.url || image
            preload.images[url] = {"url": url}
        })
    })
    Object.values(game.player.party.units).forEach((unit) => {
        if(unit.portraits != undefined) {
            Object.values(unit.portraits).forEach((portrait) => {
                const imageURL = portrait
                if(imageURL == undefined) return
                preload.images[imageURL] = {"url": imageURL}
            })
        }
        if(unit.sprites != undefined) {
            Object.keys(unit.sprites).forEach((spriteKey) => {
                const sprite = unit.sprites[spriteKey]
                if(sprite.parts instanceof Array) {
                    sprite.parts.forEach((spritepart) => {
                        if(spritepart.image != undefined) {
                            const imageURL = spritepart.image
                            preload.images[imageURL] = {"url": imageURL}
                        }
                        if(spritepart.frames != undefined) {
                            spritepart.frames.forEach((frame) => {
                                const imageURL = frame.image
                                preload.images[imageURL] = {"url": imageURL}
                            })
                        }
                    })
                }
                if(sprite.frames instanceof Array) {
                    sprite.frames.forEach((frame) => {
                        const imageURL = frame.image
                        preload.images[imageURL] = {"url": imageURL}
                    })
                }
            })
        }
    })
})

export default new Preload(preload)
